import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  banner: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: '20px',
      md: '24px',
    },
  },
  chipWrapper: {
    display: 'flex',
    gap: {
      xs: '12px',
      md: '24px',
    },
  },
  chip: {
    display: 'flex',
    gap: '8px',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
